import { Container, Graphics, Sprite } from "@inlet/react-pixi/animated";
import React, { useRef, useCallback, useEffect, useState, memo } from "react";
import Back from "../Back";
import GameDialog from "./components/GameDialog";
import ShellGame from "../../games/ShellGame";
import IdentityGame from "../../games/ValidateIdentity";
import IdentityGame2 from "../../games/ValidateIdentity2";
import PhoneGame from "../../games/PhoneGame";
import FingerprintGame from "../../games/Fingerprint";
import MessagesGame from "../../games/MessagesGame";
import HusbandInfoGame from "../../games/HusbandInfoGame";
import AccountBank from "../../games/AccountBank";
import { Spring } from "react-spring";
import img1 from "../../assets/games/shellGame/game_01_intro_v2.png";
import img2 from "../../assets/games/phoneGame/game_02_intro.png";
import img3 from "../../assets/games/grabGame/inst_juego3.png";
import img4 from "../../assets/games/fingerprint/inst_juego4.png";
import img5 from "../../assets/games/messageGame/inst_juego5.png";
import img6 from "../../assets/games/CURPGame/instruccionesjuegocurp.png";
import img7 from "../../assets/games/formGame/instruccionesjuego4.png";
import img8 from "../../assets/games/pipesGame/juego5_instrucciones.png";
import img9 from "../../assets/games/clientInfoGame/juego2_instrucciones.png";
import img10 from "../../assets/games/contributionGame/juego1_instrucciones.png";
import img11 from "../../assets/games/weeksGame/juegosemanas_instrucciones.png";
import img12 from "../../assets/games/caseFileGame/juegoexpediente_instrucciones.png";
import img13 from "../../assets/games/husbandInfoGame/juegoregistro_instrucciones.png";
import img14 from "../../assets/games/constancyGame/juegoconstancias_instrucciones.png";
import img15 from "../../assets/games/loanDocsGame/instruccionesjuegotramite.png";
import img16 from "../../assets/games/pamphletGame/juego1_instrucciones.png";
import img17 from "../../assets/games/shellGame/registro_instrucciones.png";
import instructionsDocumentosParaRetiroAnticipado from "../../assets/games/docsRetiroAnticipado/paso24.png";
import instructionsDocumentosParaPrestamo from "../../assets/games/docsPrestamo/paso24.png";
import instructionsDocumentosParaPrestamo2 from "../../assets/games/docsRetiroAnticipado2/paso24.png";
import instrucionesConfirmarExpedienteDeIndentificacion from "../../assets/games/confirmarExpedienteDeIndentificacion/instrucciones.png";
import selectAccountInstructions from "../../assets/games/selectAccount/Juego_paso36.png";
import instructionsValidateIdentity from "../../assets/games/ValidarIdentidad/instrucciones.png";
import instructionsValidateIdentity2 from "../../assets/games/ValidarIdentidad2/instrucciones.png";
import gamesBg from "../../assets/games/games_bg.png";
import GrabGame from "../../games/GrabGame";
import FormGame from "../../games/FormGame";
import CURPGame from "../../games/CURPGame";
import PipesGame from "../../games/PipesGame";
import ClientInfoGame from "../../games/ClientInfoGame";
import ContributionGame from "../../games/ContributionGame";
import WeeksGame from "../../games/WeeksGame";
import CaseFileGame from "../../games/CaseFileGame";
import ConstancyGame from "../../games/ConstancyGame";
import LoanDocsGame from "../../games/LoanDocsGame";
import PamphletGame from "../../games/PamphletGame";
import DocumentosParaRetiroAnticipado from "../../games/DocumentosParaRetiroAnticipado";
import DocumentosParaPrestamo from "../../games/DocumentosParaPrestamo";
import DocumentosParaPrestamo2 from "../../games/DocumentosParaPrestamo2";
import DocumentosParaPrestamo3 from "../../games/DocumentosParaPrestamo3";
import ConfirmarExpedienteDeIndentificacion from "../../games/ConfirmarExpedienteDeIndentificacion";
import SelectAccount from "../../games/SelectAccount";
import instruccionesBankAccount from "../../assets/games/AccountBank/_0000_instrucciones.png";
import AccountMemory from "../../games/AccountMemory";
import AccountMemoryInstructions from "../../assets/games/AccountMemory/juego_edocuenta_instrucciones.png";
import BankTransferGame from "../../games/TranferenciaPrestamo";
import bankTransferGameInstructions from "../../assets/games/TransferenciaPrestamo/transferencia_instr.png";
//import { useDispatch } from "react-redux";
//import { useDispatch } from "react-redux";
//import { addTime } from "../../redux/features/registry/registry";

const Index = memo(
  ({ id, lastId, close, back = () => null }) => {
    const spring = { mass: 6, tension: 1000, friction: 100 };

    useEffect(() => {
      return () => {
        //console.log("UNMONT");
        //setClose(false);
      };
    }, []);
    const Animated = () => {
      //const dispatch = useDispatch();
      const scale = window.innerWidth / 1536;
      const [isGameVisible, setGameVisible] = useState(false);
      const [isClose, setClose] = useState(false);
      const mask = useRef();
      const tries = useRef(0);

      const background = useCallback((g) => {
        g.clear();
        g.beginFill(0xffffff, 0.7);
        g.drawRect(0, 0, window.innerWidth, window.innerHeight);
        g.endFill();
      });

      useEffect(() => {
        return () => {
          //console.log("UNMONT");
          //setClose(false);
        };
      }, []);

      const handleClose = (stay, gameId) => {
        setClose(true);
        document.querySelector(".gameHTMLContainer").style.opacity = 0;
        setTimeout(() => {
          close(stay, gameId);
          document.querySelector(".gameHTMLContainer").style.opacity = 1;
        }, 500);
      };

      const handleBack = () => {
        handleClose(true);
        back();
      };

      const handleAddTime = (time) => {
        //dispatch(addTime(time));
        //showGame(true);
      };

      // 23 games
      const games = [
        {
          index: 0,
          game: (
            <ShellGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
              addTime={(time) => handleAddTime(time)}
            />
          ),
          image: img1,
          dialogButton: "Buscar",
        },
        {
          index: 1,
          game: (
            <PhoneGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: img2,
          dialogButton: "Marcar",
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 225,
          ],
        },
        {
          index: 2,
          game: (
            <GrabGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: img3,
        },
        {
          index: 3,
          game: (
            <FingerprintGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: img4,
        },
        {
          index: 4,
          game: (
            <MessagesGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: img5,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 225,
          ],
        },
        {
          index: 5,
          game: (
            <CURPGame
              visible={isGameVisible}
              close={(gameId) => handleClose(false, gameId)}
              reset={() => showGame(false)}
              useReset={false}
              time={false}
            />
          ),
          image: img6,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 220,
          ],
        },
        {
          index: 6,
          game: (
            <FormGame
              visible={isGameVisible}
              close={(gameId) => handleClose(false, gameId)}
              reset={() => showGame(false)}
            />
          ),
          image: img7,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 180,
          ],
        },
        {
          index: 7,
          game: (
            <PipesGame
              visible={isGameVisible}
              close={(gameId) => handleClose(false, gameId)}
              reset={() => showGame(false)}
            />
          ),
          image: img8,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 180,
          ],
        },
        {
          index: 8,
          game: (
            <ClientInfoGame
              visible={isGameVisible}
              close={(gameId) => handleClose(false, gameId)}
              reset={() => showGame(false)}
            />
          ),
          image: img9,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 180,
          ],
        },
        {
          index: 9,
          game: (
            <ContributionGame
              visible={isGameVisible}
              close={(gameId) => handleClose(false, gameId)}
              reset={() => showGame(false)}
            />
          ),
          image: img10,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 180,
          ],
        },
        {
          index: 10,
          game: (
            <WeeksGame
              visible={isGameVisible}
              close={(gameId, success) => {
                setClose(true);
                document.querySelector(".gameHTMLContainer").style.opacity = 0;
                setTimeout(() => {
                  close(false, gameId, success);
                  document.querySelector(".gameHTMLContainer").style.opacity =
                    1;
                }, 500);
              }}
              reset={() => showGame(false)}
            />
          ),
          image: img11,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 180,
          ],
        },
        {
          index: 11,
          game: (
            <CaseFileGame
              visible={isGameVisible}
              close={(gameId, success) => {
                setClose(true);
                document.querySelector(".gameHTMLContainer").style.opacity = 0;
                setTimeout(() => {
                  close(false, gameId, success);
                  document.querySelector(".gameHTMLContainer").style.opacity =
                    1;
                }, 500);
              }}
              reset={() => showGame(false)}
              time={(time) => handleAddTime(time)}
            />
          ),
          image: img12,
          dialogButton: "Buscar",
        },
        {
          index: 12,
          game: (
            <CURPGame
              visible={isGameVisible}
              close={(gameId) => handleClose(false, gameId)}
              reset={() => showGame(false)}
              useReset={false}
              time={false}
            />
          ),
          image: img6,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 220,
          ],
        },
        {
          index: 13,
          game: (
            <HusbandInfoGame
              visible={isGameVisible}
              close={(gameId) => handleClose(false, gameId)}
              reset={() => showGame(false)}
            />
          ),
          image: img13,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 180,
          ],
        },
        {
          index: 14,
          game: (
            <ConstancyGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: img14,
        },
        {
          index: 15,
          game: (
            <LoanDocsGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: img15,
        },
        {
          index: 16,
          game: (
            <PamphletGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: img16,
        },
        {
          index: 17,
          game: (
            <ShellGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
              addTime={(time) => handleAddTime(time)}
              pension={true}
            />
          ),
          image: img17,
          dialogButton: "Buscar",
        },
        {
          index: 18,
          game: (
            <IdentityGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
              addTime={(time) => handleAddTime(time)}
              pension={true}
            />
          ),
          image: instructionsValidateIdentity,
          dialogButton: "Validar",
        },
        {
          index: 19,
          game: (
            <DocumentosParaRetiroAnticipado
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          dialogButton: "Validar",
          buttonPosition: [
            (window.innerWidth / 19) * 3.35,
            window.innerHeight / 1.45,
          ],
          image: instructionsDocumentosParaRetiroAnticipado,
        },
        {
          index: 20,
          game: (
            <SelectAccount
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          dialogButton: "Seleccionar",
          buttonPosition: [
            (window.innerWidth / 5) * 3.4,
            window.innerHeight / 2 + 100,
          ],
          image: selectAccountInstructions,
        },
        {
          index: 21,
          game: (
            <AccountBank
              visible={isGameVisible}
              close={(gameId) => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: instruccionesBankAccount,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 180,
          ],
        },
        {
          index: 22,
          game: (
            <AccountMemory
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: AccountMemoryInstructions,
          buttonPosition: [
            window.innerWidth / 2 - 450,
            window.innerHeight / 2 + 100,
          ],
        },
        {
          index: 23,
          game: (
            <BankTransferGame
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          image: bankTransferGameInstructions,
        },
        {
          index: 24,
          game: (
            <ConfirmarExpedienteDeIndentificacion
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          dialogButton: "Validar",
          buttonPosition: [
            (window.innerWidth / 5) * 3.4,
            window.innerHeight / 2 + 210,
          ],
          image: instrucionesConfirmarExpedienteDeIndentificacion,
        },
        {
          index: 25,
          game: (
            <DocumentosParaPrestamo
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          dialogButton: "Validar",
          buttonPosition: [
            (window.innerWidth / 13) * 3.35,
            window.innerHeight / 1.45,
          ],
          image: instructionsDocumentosParaPrestamo,
        },
        {
          index: 26,
          game: (
            <IdentityGame2
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
              addTime={(time) => handleAddTime(time)}
              pension={true}
            />
          ),
          image: instructionsValidateIdentity2,
          dialogButton: "Validar",
        },
        {
          index: 27,
          game: (
            <DocumentosParaPrestamo2
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          dialogButton: "Validar",
          buttonPosition: [
            (window.innerWidth / 13) * 3.35,
            window.innerHeight / 1.45,
          ],
          image: instructionsDocumentosParaPrestamo2,
        },
        {
          index: 28,
          game: (
            <DocumentosParaPrestamo3
              visible={isGameVisible}
              close={() => handleClose(false)}
              reset={() => showGame(false)}
            />
          ),
          dialogButton: "Validar",
          buttonPosition: [
            (window.innerWidth / 13) * 3.35,
            window.innerHeight / 1.45,
          ],
          image: instructionsDocumentosParaPrestamo2,
        },
      ];

      const showGame = (show) => {
        setGameVisible(show);
      };
      return (
        <Spring
          from={{
            alpha: games[id] ? (isClose ? 1 : 0) : games[lastId] ? 1 : 0,
            scale: games[id]
              ? isClose
                ? 1 * scale
                : 0
              : games[lastId]
                ? 1 * scale
                : 0,
            messageVisible: isGameVisible ? 1 : 0,
            gameVisible: isGameVisible ? 0 : 1,
          }}
          to={{
            alpha: games[id] ? (isClose ? 0 : 1) : 0,
            scale: games[id] ? (isClose ? 0 : 1 * scale) : 0,
            messageVisible: isGameVisible ? 0 : 1,
            gameVisible: isGameVisible ? 1 : 0,
          }}
          config={spring}
        >
          {(props) => (
            <>
              <Graphics
                draw={background}
                interactive
                alpha={props.alpha}
                scale={games[id] ? 1 : 0}
              />
              <Container
                interactive
                scale={props.scale}
                alpha={props.alpha}
                pivot={[window.innerWidth / 2, window.innerHeight / 2]}
                position={[window.innerWidth / 2, window.innerHeight / 2]}
                mask={mask.current}
              >
                <Container>
                  <Sprite
                    image={gamesBg}
                    interactive
                    alpha={props.alpha}
                    scale={games[id] ? 0.7 : 0}
                    anchor={0.5}
                    position={[window.innerWidth / 2, window.innerHeight / 2]}
                  />
                  <Sprite
                    ref={mask}
                    image={gamesBg}
                    interactive
                    alpha={props.alpha}
                    scale={games[id] ? 0.7 : 0}
                    anchor={0.5}
                    position={[window.innerWidth / 2, window.innerHeight / 2]}
                  />
                  {!isGameVisible && (
                    <Container
                      alpha={props.messageVisible}
                      scale={props.messageVisible}
                      pivot={[window.innerWidth / 2, window.innerHeight / 2]}
                      position={[window.innerWidth / 2, window.innerHeight / 2]}
                    >
                      <GameDialog
                        image={games[id] && games[id].image}
                        close={() => {
                          tries.current++;
                          showGame(true);
                        }}
                        showSkip={tries.current > 2}
                        skip={() => handleClose(false)}
                        button={games[id] && games[id].dialogButton}
                        buttonPosition={games[id] && games[id].buttonPosition}
                      />
                    </Container>
                  )}
                </Container>
                <Container
                  interactive={isGameVisible ? 1 : 0}
                  alpha={props.gameVisible}
                  scale={props.gameVisible}
                  pivot={[window.innerWidth / 2, window.innerHeight / 2]}
                  position={[window.innerWidth / 2, window.innerHeight / 2]}
                >
                  {games[id] && games[id].game}
                </Container>
              </Container>
              {games[id] && <Back click={() => handleBack()} />}
            </>
          )}
        </Spring>
      );
    };

    return <Animated />;
  },
  (a, b) => a.id === b.id,
);

export default Index;
